// src/defaultBrandTheme.js

const DefaultStyles = {
    general: {
        buttons: {
            backgroundColor: "#1976d2",
            hoverColor: "#156CB3",
            textColor: "#FFFFFF",
            fontFamily: "Arial",
        },
        logo: {
            url: "https://cdn.prod.website-files.com/6727ba04af2a33d9f11be20f/6727bae3ac6214ff01f0544f_logo-256x256.png"
        }
    },
    products: {
        title: {
            fontWeight: 600,
            color: "#211F26",
            fontSize: "16px",
            lineHeight: "normal"
        },
        details: {
            fontSize: "14px",
            color: "#65636D"
        },
        container: {
            borderRadius: "8px"
        },
        image: {
            aspectRatio: "1 / 1.5"
        }
    },
    productsGrid: {
        gridTemplateColumns: "1fr 1fr 1fr",
        gridGap: "1em"
    },
    searchBar: {
        width: "400px",
        injectedContainer: {
            desktop: {},
            mobile: {}
        }
    }
};

export default DefaultStyles;